import React from 'react';
import { VIP_FEEDBACK_RATE, SPECS, CITY, TOWN } from '../../constants';
import numbro from 'numbro';

function Invoice(props) {
    const {
        invType,
        invTitle,
        invTaxNo,
        email,
        cityCode,
        townCode,
        address
    } = props.data;
    const cityName = CITY.find(entry => entry.value === cityCode).name;
    const townName = TOWN[cityCode].find(entry => entry.value === townCode).name;
    switch (invType) {
        case 1:
            return <p>捐贈至陽光基金會</p>;
        case 5:
            return (
                <p>
                    二聯式
                    <br />
                    Email: {email}
                    <br />
                    地址: {cityName} {townName} {address}
                </p>
            );
        case 6:
            return (
                <p>
                    三聯式
                    <br />
                    Email: {email}
                    <br />
                    發票抬頭: {invTitle}
                    <br />
                    統一編號: {invTaxNo}
                    <br />
                    地址: {cityName} {townName} {address}
                </p>
            );
        default:
            return <p>Error</p>;
    }
}

function OrderDetail(props) {
    const { userInfo, data, paymentMethods, order } = props;
    const { vipCardLevel, vipStatus } = userInfo;
    let { paymentMethod, spec } = data;
    const {
        name,
        phone,
        gender
    } = data;
    if (!paymentMethod) {
        paymentMethod = order.paymentMethodId;
    }
    // 若 Order 已建立，從order取 spec, 而非 default值
    if(order) {
        spec = order.specificationId;
    }
    const method = paymentMethods.find(entry => entry.id === paymentMethod).name;
    const feedbackRate = vipStatus ? VIP_FEEDBACK_RATE[vipCardLevel] : 0;

    const amount = SPECS.find(entry => entry.id === spec).price;
    const feedback = amount * feedbackRate;
    return (
        <dl className="dl-horizontal" style={{ padding: '0px 50px' }}>
            <dt>付款方式</dt><dd>{method}</dd>
            <dt>購買金額</dt><dd>{numbro(amount).format('0,0')} 元</dd>
            <dt>兌換Pub點數</dt><dd>{numbro(amount).format('0,0')} Pub點</dd>
            <dt>回饋Pub點數</dt><dd>{numbro(feedback).format('0,0')} Pub點</dd>
            <dt>購買人姓名</dt><dd>{name}</dd>
            <dt>購買人性別</dt><dd>{gender === 'M' ? '男' : '女'}</dd>
            <dt>購買人手機</dt><dd>{phone}</dd>
            <dt>發票</dt><dd><Invoice data={props.data} /></dd>
        </dl>
    );
}

export default OrderDetail;


// WEBPACK FOOTER //
// ./src/containers/shop/orderDetail.jsx